var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVectorBanner2 = function SvgVectorBanner2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 114,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vector-banner2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB008C",
    d: "M177 90.312c0 49.879-36.507 90.317-81.536 90.317H-60.684S23.045 42.823 37.783 26.483c7.562-8.406 16.55-15.074 26.447-19.618C74.127 2.32 84.737-.013 95.45 0 140.494 0 177 40.433 177 90.312"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vector-banner2_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 114,
    fill: "#fff",
    rx: 24
  })))));
};
export default SvgVectorBanner2;